const STORAGE_KEY = "hss_admin_token";

export const getAdminKey = () => sessionStorage.getItem(STORAGE_KEY);
export const setAdminKey = (token) => sessionStorage.setItem(STORAGE_KEY, token);
export const clearAdminKey = () => sessionStorage.removeItem(STORAGE_KEY);

export const isTokenExpired = () => {
  const token = getAdminKey();
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
};

export const isAuthenticated = () => Boolean(getAdminKey()) && !isTokenExpired();
